<div class="header-container">
  <div  id="navbar"  class="login-page-header" >
    <div class="buttons-container">
      <div class="login-btn" [class.login-right]="_translate.currentLang !== 'ar'"
           [class.login-left]="_translate.currentLang === 'ar'">
        <button mat-button [routerLink]="['/index/login']">
          {{ "LOGIN.LOGIN" | translate }}
        </button>
      </div>
      <div class="register-btn" [class.register-right]="_translate.currentLang !== 'ar'"
           [class.register-left]="_translate.currentLang === 'ar'">
        <button mat-button [routerLink]="['/index/register']" style="color: white;">
          {{ "LOGIN.REGISTER" | translate }}
        </button>
      </div>
      <div class="lang-btn" mat-icon-button [matMenuTriggerFor]="menu"
           [class.lang-btn-left]="_translate.currentLang === 'ar'"
           [class.lang-btn-right]="_translate.currentLang !== 'ar'"><img class="lang-icon"
                                                                         src="./assets/images/login/{{_translate.currentLang}}.png"
                                                                         alt="">
        <span [class.curr-lang-right]="_translate.currentLang === 'ar'"
              [class.curr-lang-left]="_translate.currentLang !== 'ar'">{{_translate.currentLang | titlecase }}</span>
        <mat-icon class="lang-icon" style="margin: 0;">arrow_drop_down</mat-icon>
      </div>
      <mat-menu #menu="matMenu">
        <button style="display: flex; justify-content: space-evenly; align-items: center;" class="sub-lang-btn"
                mat-menu-item (click)="changeLanguage()">{{_translate.currentLang === 'ar' ? 'English' : 'عربي'}}<img
          style="max-width: 20px;" src="./assets/images/login/{{_translate.currentLang === 'ar'? 'en' : 'ar'}}.png"/>
        </button>
      </mat-menu>

    </div>
    <div [class.logo-container-right]="_translate.currentLang === 'ar'"
         [class.logo-container-left]="_translate.currentLang !== 'ar'">
      <img routerLink="/index" alt="5dma"  class="logo-image" src="./assets/images/login/logo.png"/>
    </div>
  </div>
</div>

